module.exports = __webpack_public_path__ + "static/media/2x5B-open.2eb69f64.svg";